import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { notificationsEndpoints } from '@/modules/notifications/constants';
import { notificationsQueryKeys } from '@/modules/notifications/queries/queryKeys';

export const useUnreadNotificationMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (notificationId: string) => {
      const { data } = await fetchClient.PUT(
        notificationsEndpoints.unreadNotification,
        {
          params: { path: { id: notificationId } },
        },
      );
      return data;
    },
    onSettled: () =>
      queryClient.invalidateQueries({
        queryKey: notificationsQueryKeys.list(),
      }),
  });
};
